/* IMPORT */
import Abstract from './abstract.js';
/* MAIN */
class AbstractInput extends Abstract {
}
/* EXPORT */
export default AbstractInput;
